import styled, { keyframes } from 'styled-components';

// Keyframes animations needs to be on top
const fadeInAnimation = keyframes`
  from {
    opacity: 0;
    transform: ${props =>
      props.transform
        ? props.transform
        : handleAnimationDirection(props.direction)};
  }

  to {
    opacity: 1;
    transform: translate(0, 0);
  }
`;

/* 
  Usage: wrap component you want to animate with <FadeInAnimation>
  Example:
   <FadeInAnimation 
      direction="up"
      duration="0.5s"
      delay="0.2s"
      >
      <ComponentToAnimate />
    </FadeInAnimation>
*/

const handleAnimationDirection = direction => {
  switch (direction) {
    case 'up':
      return 'translate(0, 25%)';
    case 'down':
      return 'translate(0, -25%)';
    case 'right':
      return 'translate(-25%, 0)';
    case 'left':
      return 'translate(25%, 0)';
    default:
      return;
  }
};

export const FadeInAnimation = styled.div`
  animation: ${fadeInAnimation} ${props => props.duration && props.duration}
    ease forwards;
  animation-delay: ${props =>
    props.delay ? Object.values(props.delay) : '0s'};
  transform: ${props =>
    props.direction
      ? handleAnimationDirection(props.direction)
      : props.transform};
  opacity: 0;

  /* disable animations if user enabled reduced motion in OS/browser */
  @media (prefers-reduced-motion) {
    animation: none;
    opacity: 1;
  }
`;
